import { DpSentrySetUser } from '@docupet/component-library';
import PetOwnerService from '@/api/services/PetOwnerService';

export const namespaced = true;

export const state = {
  petOwner: {},
  loading: false,
};

export const mutations = {
  SET_PETOWNER(state, petOwner) {
    state.petOwner = petOwner;
    if (petOwner) {
      DpSentrySetUser(petOwner?.id, petOwner?.email);
    }
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
};

export const actions = {
  fetchPetOwner({ commit, dispatch }) {
    commit('LOADING', true);
    PetOwnerService.getPetOwner()
      .then(response => {
        commit('SET_PETOWNER', response);
        commit('LOADING', false);
      })
      .catch(error => {
        // if (window.BASE_URL) {
        //   window.location.href = `${window.BASE_URL}/login`;
        // }
        commit('LOADING', false);
        const notification = {
          type: 'warning',
          message: 'There was an problem fetching the PetOwner:' + error.message,
        };

        dispatch('notification/add', notification, { root: true });
      });
  },
  setPetOwnerAddresses({ commit, dispatch }, { home, mailing }) {
    commit('LOADING', true);
    PetOwnerService.setAddresses(home, mailing)
      .then(response => {
        commit('SET_PETOWNER', response);
        commit('LOADING', false);
      })
      .catch(error => {
        commit('LOADING', false);
        const notification = {
          type: 'warning',
          message: 'There was an problem fetching the PetOwner:' + error.message,
        };

        dispatch('notification/add', notification, { root: true });
      });
  },
};

export const getters = {
  getPetById: state => id => {
    if (state.petOwner) {
      return state.petOwner.pets.find(pet => pet.id === id);
    }

    return null;
  },
  proofsRequired: state => {
    if (state.petOwner.pets && state.petOwner.pets.length > 0) {
      let needsUploads = state.petOwner.pets.find(pet =>
        state.skippedDocs.includes(pet.id)
          ? false
          : (pet.needsRabiesProof && !pet.hasValidRabiesProof && !pet.hasWaitingRabiesProof) ||
            (pet.needsNeuterProof && !pet.hasValidNeuterProof && !pet.hasWaitingNeuterProof)
      );

      return !!needsUploads;
    }
  },
  getLicensesByPetId: state => id => {
    return state.licensesByPet.find(licenseGroup => licenseGroup.pet === id);
  },
};
